import React from 'react'

import { useParams } from 'react-router-dom'

import { Navigate, Routes, Route } from 'react-router-dom'

import CanRoute from '~/components/Authorisation/CanRoute'
import { HeaderSection } from '~/components/Profiles/Detail'
import Tabs from '~/components/Tabs'
import { useSelectedServiceFkey } from '~/contexts/Service'
import { roomProfiles as rProf } from '~/modules/permissions'
import { ScrollUp } from '~/utils'
import toFkey from '~/utils/toFkey'

import Documents from './Documents'
import Summary from './Summary'

const Room = () => {
  const { fkey: fkeyOrId } = useParams<{ fkey: string }>()
  const serviceFkey = useSelectedServiceFkey()
  if (!fkeyOrId) return null
  const roomFkey = toFkey(fkeyOrId)
  return (
    <ScrollUp>
      <HeaderSection>
        <Summary roomFkey={roomFkey} serviceFkey={serviceFkey} />
        <Tabs
          tabs={[
            {
              key: 'documents-tab',
              path: `/rooms/${fkeyOrId}`,
              label: 'Learning',
              permission: { action: rProf.readDocuments },
            },
          ]}
        />
      </HeaderSection>
      <Routes>
        <Route
          path="/*"
          element={
            <CanRoute
              perform={rProf.readDocuments}
              no={() => <Navigate to="/rooms" replace />}
              yes={() => <Documents roomFkey={roomFkey} serviceFkey={serviceFkey} />}
            />
          }
        />
      </Routes>
    </ScrollUp>
  )
}

Room.displayName = 'Room'

export default Room
